<ion-grid>
  <ion-row>
    <ion-col *ngIf="!showError" size="12">
      <ion-row class="aboutme-container-row">
        <ion-col *ngIf="isPushAvailable">
          <div class="aboutMeContainer">
            <h2>Varslinger fra appen</h2>
            <div
              *ngIf="permission === false"
              class="bg-white p-3 rounded-lg mb-4"
            >
              <p class="mt-0">
                Denne enheten er ikke registrert for å motta pushvarslinger
                enda. Trykk nedenfor for å aktivere.
              </p>
              <ion-button class="secondary" (click)="requestPermissions()">
                Skru på pushvarslinger
              </ion-button>
            </div>

            <ion-item class="check ion-margin-top" lines="none" *ngIf="kundeId">
              <ion-checkbox
                mode="md"
                [disabled]="!permission"
                (ionChange)="toggleTomorrowSpotPush($event)"
                [checked]="checkedTomorrowSpot === true"
                name="push1"
                id="push1"
              >
              </ion-checkbox>
              <ion-label for="push1" class="ion-text-wrap">
                <b>Morgendagens spotpris</b>
                <span class="block text-sm"
                  >Varselet sendes ut litt etter kl. 13:00 daglig med priser for
                  ditt område</span
                >
              </ion-label>
            </ion-item>
            <ion-item class="check ion-margin-top" lines="none" *ngIf="kundeId">
              <ion-checkbox
                mode="md"
                [disabled]="!permission"
                (ionChange)="toggleDayMaxExceededPush($event)"
                [checked]="checkedDayMaxExceeded === true"
                name="push2"
                id="push2"
              >
              </ion-checkbox>
              <ion-label for="push2" class="ion-text-wrap">
                <b>Nettleieanalyse: høy døgnmaks</b>
                <span class="block text-sm"
                  >Varselet sendes ut rundt kl. 12:00 hvis du hadde en uventet
                  høy døgnmaks dagen før (eksperimentell)</span
                >
              </ion-label>
            </ion-item>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6">
          <div class="aboutMeContainer">
            <h2>Innstillinger</h2>
            <ion-item class="check ion-margin-top" lines="none">
              <ion-checkbox
                mode="md"
                (ionChange)="toggleShowEnodeInMenu()"
                [checked]="showEnodeInMenu === true"
                name="set1"
                id="set1"
              >
              </ion-checkbox>
              <ion-label for="set1" class="ion-text-wrap">
                Vis Smartlading i hovedmeny</ion-label
              >
            </ion-item>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6">
          <div
            *ngIf="
              (_kundeResponse | async)?.kunde;
              let kunde;
              else: loadingContainer
            "
            class="aboutMeContainer"
          >
            <h2>Generelt</h2>
            <div class="bg-white p-3 rounded-lg">
              <p class="m-0 text-lg"><strong>Navn</strong></p>
              <p class="mt-0">{{ kunde.fornavn }} {{ kunde.etternavn }}</p>
              <p class="m-0 mt-3 text-lg"><strong>Kundenummer</strong></p>
              <p class="mt-0">{{ kunde.kunde_id }}</p>
              <p class="m-0 mt-3 text-lg"><strong>Målernummer</strong></p>
              <p class="mt-0" *ngFor="let a of anlegg">
                {{
                  a.maalerid
                    ? a.maalerid + ' - ' + a.adresse
                    : 'Finner ikke målernummer'
                }}
              </p>

              <ion-button
                *ngIf="canChangeKunde"
                class="secondary pad-end"
                (click)="navigateToPasswordEdit()"
                >Endre passord
                <ion-icon slot="end" name="arrow-forward-outline"></ion-icon
              ></ion-button>

              <ion-button
                class="dark-primary"
                *ngIf="_showBrukerkunde"
                (click)="showBrukerkunde()"
                >Bytt aktivt kundeforhold
                <ion-icon slot="end" name="arrow-forward-outline"></ion-icon
              ></ion-button>
            </div>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6">
          <div
            *ngIf="
              (_kundeResponse | async)?.kunde;
              let kunde;
              else: loadingContainer
            "
            class="aboutMeContainer"
          >
            <h2>Kontaktinfo</h2>
            <div class="bg-white p-3 rounded-lg">
              <p class="m-0 text-lg"><strong>Postadresse</strong></p>
              <div>
                <p class="m-0" *ngIf="kunde.adresse_1">
                  C/O {{ kunde.adresse_1 }}
                </p>
                <p class="m-0">
                  {{ kunde.adresse_2 }}
                </p>
                <p class="mt-0">{{ kunde.postnr }} {{ kunde.poststed }}</p>
              </div>
              <p class="m-0 mt-3 text-lg"><strong>E-postadresse</strong></p>
              <p class="mt-0">
                {{ kunde.epost }}
              </p>
              <p class="m-0 mt-3 text-lg"><strong>Mobilnummer</strong></p>
              <p class="mt-0">{{ kunde.mobilnr | phone }}</p>

              <ion-button
                class="secondary"
                (click)="navigateToContactEdit()"
                *ngIf="canChangeKunde && isEndreKontaktinfoToggled"
              >
                Rediger kontaktinfo
                <ion-icon slot="end" name="arrow-forward-outline"></ion-icon
              ></ion-button>
              <p class="small-info-profile">
                For overføring av abonnement eller andre endringer vennligst
                kontakt kundeservice.
              </p>
            </div>
          </div>
        </ion-col>

        <ion-col
          size="12"
          *ngIf="
            (_samtykkeResponse | async)?.samtykke;
            let minesamtykker;
            else: loadingContainer
          "
        >
          <div class="aboutMeContainer">
            <h2>Samtykker</h2>

            <ion-item class="check" lines="none">
              <ion-checkbox
                mode="md"
                [disabled]="!canChangeKunde"
                (ionChange)="changeSamtykke(1, $event)"
                checked="{{ minesamtykker.nyheterIshavskraftSmsEpost }}"
                name="samtykke1"
                id="samtykke1"
              >
              </ion-checkbox>
              <ion-label for="samtykke1" class="ion-text-wrap">
                Jeg mottar gjerne nyheter og gode tilbud på SMS og e-post fra
                Ishavskraft</ion-label
              >
            </ion-item>

            <ion-item class="check" lines="none">
              <ion-checkbox
                mode="md"
                [disabled]="!canChangeKunde"
                (ionChange)="changeSamtykke(2, $event)"
                checked="{{ minesamtykker.nyheterPartnereSmsEpost }}"
                name="samtykke2"
                id="samtykke2"
              >
              </ion-checkbox>
              <ion-label for="samtykke2" class="ion-text-wrap">
                Jeg mottar gjerne gode tilbud fra Ishavskraft sine
                samarbeidspartnere* på SMS og e-post</ion-label
              >
            </ion-item>

            <ion-item class="check" lines="none">
              <ion-checkbox
                mode="md"
                [disabled]="!canChangeKunde"
                (ionChange)="changeSamtykke(3, $event)"
                checked="{{ minesamtykker.tilbudTelefon }}"
                name="samtykke3"
                id="samtykke3"
              >
              </ion-checkbox>
              <ion-label for="samtykke3" class="ion-text-wrap">
                Ishavskraft kan kontakte meg via telefon for å gi meg gode
                tilbud</ion-label
              >
            </ion-item>

            <ion-item class="check" lines="none">
              <ion-checkbox
                mode="md"
                [disabled]="!canChangeKunde"
                (ionChange)="changeSamtykke(4, $event)"
                checked="{{ minesamtykker.tillaterSporing }}"
                name="samtykke4"
                id="samtykke4"
              >
              </ion-checkbox>
              <ion-label for="samtykke4" class="ion-text-wrap">
                Ishavskraft kan benytte anonymisert bruksdata for å bedre
                brukeropplevelsen</ion-label
              >
            </ion-item>

            <p>
              * Ishavskraft kan dele kontaktinformasjon med samarbeidspartnere
              som til enhver tid fremgår her:
              <a
                (click)="
                  navigateTo('https://www.ishavskraft.no/samarbeidspartnere')
                "
                >ishavskraft.no/samarbeidspartnere<ion-icon
                  name="open-outline"
                  size="small"
                ></ion-icon></a
              >.
            </p>

            <div class="personvern">
              <a
                target="_blank"
                href="https://www.ishavskraft.no/om/personvern/"
                >Personvernerklæringen vår finner du her<ion-icon
                  name="open-outline"
                  size="small"
                ></ion-icon
              ></a>
            </div>
          </div>
        </ion-col>
        <ion-col size="12" *ngIf="canChangeKunde">
          <div class="deleteMeContainer p-3">
            <p>Ønsker du å slette din bruker på Min Side?</p>
            <ion-button (click)="deleteKCUser()" class="secondary">
              Se muligheter for å slette bruker
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </ion-button>
          </div>
        </ion-col>
        <ion-col size="12" *ngIf="!canChangeKunde" class="p-3">
          <p>
            Du er på en delt kundetilgang, og kan derfor ikke endre på denne
            profilen.
          </p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="md:pl-6">
          <div class="p-3">
            <app-logout></app-logout>
          </div>
        </ion-col>
      </ion-row>
    </ion-col>

    <ion-col *ngIf="showError">
      <div class="spinner">Fant ingen kundeprofil ...</div>
    </ion-col>
  </ion-row>
</ion-grid>

<ng-template #loadingContainer>
  <div class="spinner">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
